<template>
	<form method="post" enctype="multipart/form-data" ref="formAddUser" @submit.prevent="addUser">
		<input name="_token" type="hidden" :value="csrfToken">
		<div class="row row-cards">	
			<div class="col-12 col-md-6 col-lg-6">
				<div class="row row-cards">	
					<div class="col-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Profile</h3>
							</div>
							<div class="card-body">
								<div class="form-group mb-3">
									<label class="form-label required" for="email">Email</label>
									<input type="email" name="email" v-model="userData.email" v-on:change="checkEmail" class="form-control" id="email" aria-describedby="emailHelp" placeholder="Enter email">
									<small v-if="!emailIsRequired" class="form-hint text-danger">
										Please enter Email.
									</small>
									<small v-if="emailIsInvalid" class="form-hint text-danger">
										Email is invalid.
									</small>
									<small v-if="emailAlreadyTaken" class="form-hint text-danger">
										Email already taken. Please use other email
									</small>
								</div>
								<div class="form-group mb-3">
									<label class="form-label required" for="name">Name</label>
									<input type="text" class="form-control" v-model="userData.name" id="name" name="name" placeholder="Enter Name">
									<small v-if="!nameIsRequired" class="form-hint text-danger">
										Please enter Name.
									</small>
								</div>
								<div class="form-group mb-3">
									<label class="form-label required" for="phone">Phone</label>
									<input type="text" maxlength="20" class="form-control" v-model="userData.phone" id="phone" name="phone" placeholder="Enter Phone">
									<small v-if="!phoneIsRequired" class="form-hint text-danger">
										Please enter Phone.
									</small>
									<small v-if="phoneMustNumeric" class="form-hint text-danger">
										Phone must be numeric.
									</small>
								</div>
								<div class="form-group mb-3">
									<label class="form-label" for="ic">IC No</label>
									<input type="text" maxlength="20" class="form-control" v-model="userData.ic" id="ic" name="ic" placeholder="Enter IC No">
									<small v-if="icMustNumeric" class="form-hint text-danger">
										IC must be numeric.
									</small>
								</div>
								<div class="form-group mb-3">
									<label class="form-label required">Gender</label>
									<div>
										<label class="form-check form-check-inline">
											<input class="form-check-input" v-model="userData.gender" name="gender" id="male" type="radio" value="male">
											<span class="form-check-label" for="male">Male</span>
										</label>
										<label class="form-check form-check-inline">
											<input class="form-check-input" v-model="userData.gender" name="gender" id="female" type="radio" value="female">
											<span class="form-check-label" for="female">Female</span>
										</label>
									</div>
									<small v-if="!genderIsRequired" class="form-hint text-danger">
										Please select Gender.
									</small>
								</div>
							
							</div>
						</div>						
					</div>
					<div class="col-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Contact</h3>
							</div>
							<div class="card-body">
								<div class="form-group mb-3">
									<label class="form-label" for="address_line_1">Address Line 1</label>
									<input type="text" class="form-control" v-model="userData.address_line_1" id="address_line_1" name="address_line_1" placeholder="Enter Address Line 1">
								</div>
								<div class="form-group mb-3">
									<label class="form-label" for="address_line_2">Address Line 2</label>
									<input type="text" class="form-control" v-model="userData.address_line_2" id="address_line_2" name="address_line_2" placeholder="Enter Address Line 2">
								</div>
								<div class="form-group mb-3">
									<label class="form-label" for="postcode">Postcode</label>
									<input type="text" class="form-control" maxlength="5" v-model="userData.postcode" id="postcode" name="postcode" placeholder="Enter Postcode">
									<small v-if="postcodeMustNumeric" class="form-hint text-danger">
										Postcode must be numeric.
									</small>
								</div>
								<div class="form-group mb-3">
									<label class="form-label" for="city">City</label>
									<input type="text" class="form-control" v-model="userData.city" id="city" name="city" placeholder="Enter City">
								</div>
								<div class="form-group mb-3">
									<label class="form-label" for="state">State</label>
									<select class="form-select" v-model="userData.state" name="state">
										<option value="">-- Select State --</option>
										<option v-for="(value, index) in states" :value="value.name">{{ value.name }}</option> 
									</select>
								</div>
								<div class="form-group mb-3">
									<label class="form-label" for="country">Country</label>
									<select class="form-select" v-model="userData.country" name="country">
										<option value="">-- Select Country --</option>
										<option v-for="(value, index) in countries" :value="value.name">{{ value.name }}</option> 
									</select>
								</div>
							</div>
						</div>						
					</div>
				</div>
			</div>

			<div class="col-12 col-md-6 col-lg-6">
				<div class="row row-cards">	
					<div class="col-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Password</h3>
							</div>
							<div class="card-body">
								<div class="form-group mb-3 ">
									<label class="form-label required">New Password</label>
									<div>
										<input name="password" v-model="userData.password" type="password" class="form-control" maxlength="20" placeholder="Enter New Password">
										<small v-if="!passwordIsRequired" class="form-hint text-danger">
											Password is required.
										</small>
										<small v-if="passwordNotLong" class="form-hint text-danger">
											Passwords must be at least 6 characters in length.
										</small>
									</div>
								</div>
								<div class="form-group mb-3 ">
									<label class="form-label required">Confirm New Password</label>
									<div>
										<input name="password_confirmation" v-model="userData.password_confirmation" type="password" class="form-control" maxlength="20" placeholder="Enter Confirm New Password">
										<small v-if="!confirmPasswordIsRequired" class="form-hint text-danger">
											Confirm Password is required.
										</small>
										<small v-if="confirmPasswordIsNotMatch" class="form-hint text-danger">
											Confirm Password is not match.
										</small>
									</div>
								</div>						
							</div>
						</div>						
					</div>
					<div class="col-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Role</h3>
							</div>
							<div class="card-body">
								<div class="form-group mb-3">
									<label class="form-label required">Select</label>
									<select class="form-select" v-model="userData.role" name="role" v-on:change="checkRole">
										<option value="">-- Select Role --</option>
										<option v-for="(value, index) in roles" :value="value.name">{{ value.name }}</option> 
									</select>
									<small v-if="!roleIsRequired" class="form-hint text-danger">
										Please select Role.
									</small>
								</div>
								<div class="form-group mb-3">
									<label class="form-label required" for="department">Group</label>
									<select class="form-select" id="department" v-model="userData.group" name="group">
										<option value="" selected>-- Select Department --</option>	 
										<option v-if="optionCustomer" value="18">AAFIYAT COMMUNITY</option>
										<option v-if="optionStaff" value="17">AAFIYAT GROUP</option>
										<option v-if="optionStaff" value="19">KNOWLEDGE EVALUATOR</option>
									</select>
									<small v-if="!departmentIsRequired" class="form-hint text-danger">
										Please select Department.
									</small>					
								</div>	
							</div>
						</div>						
					</div>
					<div class="col-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Avatar</h3>
							</div>
							<div class="card-body">
	                            <div class="mb-3 ">                                  
	                                <img :src="avatar_url" style="width: 100px; height: 100px; border: 2px solid rgb(241, 241, 241); object-fit: cover;">
	                            </div>
	                            <div v-if="upload_progress" class="mb-3">
	                                <progress class="progress progress-sm" :value.prop="upload_percentage" max="100"/>
	                            </div>   
		                        <div class="mb-3">
		                            <div class="form-label">Browse Image</div>
		                            <input type="file" v-on:change="uploadAvatar" name="file" class="form-control" accept="image/png, image/jpeg, image/jpg">
		                            <input type="hidden" name="avatar" v-model="userData.avatar">
		                            <small v-if="upload_message" class="form-hint">
		                                {{ message }}
		                            </small>
		                        </div>   
							</div>
						</div>						
					</div>
				</div>
			</div>

			<div class="col-12 col-md-12 col-lg-12">
				<div class="card">
					<div class="card-body">
						<button type="submit" v-on:click="addUser" :disabled="validateForm" class="btn btn-primary">Submit</button>
					</div>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
	export default {
        props: ['data'], 
        data() {
        	return {
        		csrfToken: "",
        		userData: {
        			email: "",
        			name: "",
        			phone: "",
        			ic: "",
        			gender: "",
        			address_line_1: "",
        			address_line_2: "",
        			address_line_3: "",
        			postcode: "",
        			city: "",
        			state: "",
        			country: "Malaysia",
        			password: "",
        			password_confirmation: "",
        			role: "",
        			group: "",
        			avatar: "",
        		},
        		hitButtonAdd: false,
        		countries: [],
        		roles: [],
        		departments: [],
        		states: [],
        		user_exist: false,
        		is_typing: false,
        		avatar_url: window.location.origin + '/images/default.png',
        		upload_progress: false,
        		upload_percentage: 0,
        		message: "",
        		upload_message: false,
        		optionCustomer: false,
        		optionStaff: false,
        	};
        },   
        mounted() {
        	this.csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;
        	this.getCountries();
        	this.getRoles();
        	this.getStates();
        }, 
        methods: {
        	addUser() {
        	    this.hitButtonAdd = true;
        	    this.$refs.formAddUser.submit();
        	},
        	getCountries() {
        	    axios.get('/api/ajax/mod/users/countries').then(res => {
        	        this.countries = res.data.countries;
        	    });
        	},
        	getRoles() {
        	    axios.get('/api/ajax/mod/users/roles').then(res => {
        	        this.roles = res.data.roles;
        	    });
        	},
        	getStates() {
        	    axios.get('/api/ajax/mod/users/states').then(res => {
        	        this.states = res.data.states;
        	    });
        	},
        	validEmail: function (email) {
        		var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        		return re.test(email);
        	},
        	isNumeric(number) {
        		return !isNaN(parseFloat(number)) && !isNaN(+number);
        	},
        	checkEmail(e) {
        		let email = e.target.value;
        		if (this.validEmail(email)) {
        			const form = new FormData();
        			form.append('email', email);
        			axios.post('/api/ajax/mod/users/check/email', form)
        			.then(res => {
        				if (res.data.is_exist) {
        					this.user_exist = true;
        				}
        				else {
        					this.user_exist = false;
        				}
        				this.is_typing = false;
        			})
        			.catch(err => {
        			    console.log(err);
        			});
        		}
        	},
    	   	uploadAvatar() {
	    		const file = event.target.files[0]; 
	    		if (file) {
	    		    this.upload_progress = true;
	    		    const form = new FormData();
	    		    form.append('file', file);
	    		    axios.post('/api/ajax/mod/users/upload/avatar',
	    		    form,
	    		    {
	    		        headers: {
	    		            'Content-Type': 'multipart/form-data'
	    		        },
	    		        onUploadProgress: function(progressEvent) {
	    		            this.upload_percentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
	    		        }.bind(this)
	    		    })
	    		    .then(res => {
	    		    	if (res.data.is_valid) {
	    		    		this.upload_message = false;
	    		    		this.message = "";
		    		    	this.userData.avatar = res.data.avatar;
		    		    	this.avatar_url = res.data.url;
				    	    this.upload_progress = false;
	    		    	}
	    		    	else {
	    		    		this.upload_message = true;
	    		    		this.message = res.data.message;
				    	    this.upload_progress = false;	    		    		
	    		    	}
	    		    })
	    		    .catch(err => {  
	    		        console.log(err);                  
	    		    });                     
	    		}  
    	   	},
    	   	checkRole() {
    	   	    if (this.userData.role) {
    	   	        if (this.userData.role == 'Customer') {
    	   	            this.optionCustomer = true;
    	   	            this.optionStaff = false;
    	   	        }
    	   	        else {
    	   	            this.optionStaff = true;
    	   	            this.optionCustomer = false;
    	   	        }
    	   	    }
    	   	    else {
    	   	        this.optionCustomer = false;
    	   	        this.optionStaff = false;
    	   	        this.userData.group = "";
    	   	    }
    	   	},
        },  
        computed: {
        	validateForm() {
        	    if (this.hitButtonAdd) {
        	        return true;
        	    }  
        	    if (!this.userData.email) {
        	        return true;
        	    }
        	    if (this.userData.email && !this.validEmail(this.userData.email)) {
        	    	return true;
        	    }
        	    if (this.userData.email && this.validEmail(this.userData.email) && this.user_exist) {
        	    	return true;
        	    }
        	    if (!this.userData.name) {
        	        return true;
        	    }
        	    if (!this.userData.phone) {
        	        return true;
        	    }
        	    if (!this.isNumeric(this.userData.phone)) {
        	        return true;
        	    }
        	    if (this.userData.postcode && !this.isNumeric(this.userData.postcode)) {
        	        return true;
        	    }
        	    if (this.userData.ic && !this.isNumeric(this.userData.ic)) {
        	        return true;
        	    }
        	    if (!this.userData.gender) {
        	        return true;
        	    }
        	    if (!this.userData.password) {
        	        return true;
        	    }
        	    if (this.userData.password < 6) {
        	        return true;
        	    }
        	    if (!this.userData.password_confirmation) {
        	        return true;
        	    }
        	    if (this.userData.password_confirmation != this.userData.password) {
        	        return true;
        	    }
        	    if (!this.userData.role) {
        	        return true;
        	    }
        	    if (!this.userData.group) {
        	        return true;
        	    }        	    
        	},
        	emailIsRequired() {
        		return this.userData.email;
        	},
        	emailIsInvalid() {
        		return this.userData.email && !this.validEmail(this.userData.email);
        	},
        	emailAlreadyTaken() {
        		return this.userData.email && this.validEmail(this.userData.email) && this.user_exist;
        	},
        	nameIsRequired() {
        		return this.userData.name;
        	},
        	phoneIsRequired() {
        		return this.userData.phone;
        	},
        	phoneMustNumeric() {
        		return this.userData.phone && !this.isNumeric(this.userData.phone);
        	},
        	genderIsRequired() {
        		return this.userData.gender;
        	},
        	postcodeMustNumeric() {
        		return this.userData.postcode && !this.isNumeric(this.userData.postcode);
        	},
        	icMustNumeric() {
        		return this.userData.ic && !this.isNumeric(this.userData.ic);
        	},
        	passwordIsRequired() {
        		return this.userData.password;
        	},
        	passwordNotLong() {
        		return this.userData.password && this.userData.password.length < 6;
        	},
        	confirmPasswordIsRequired() {
        		return this.userData.password_confirmation;
        	},
        	confirmPasswordIsNotMatch() {
        		return this.userData.password_confirmation && this.userData.password_confirmation != this.userData.password;
        	},
        	roleIsRequired() {
        		return this.userData.role;
        	},
        	departmentIsRequired() {
        		return this.userData.group;
        	},
        }     
	}
</script>